// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vendor-products-import-modal {
  display: flex;
  font-family: var(--font-family);
  color: #333;
}
.vendor-products-import-modal label.drop-file-container {
  padding-block: 60px;
  height: 100%;
  width: 100%;
  display: block;
  text-align: center;
  pointer-events: visible;
  cursor: pointer;
  border-radius: 4px;
  border: 1px dashed #9E9E9E;
  background: #F6F6F6;
}
.vendor-products-import-modal .upload-file-content .modal-header {
  padding-block: 20px;
  text-align: center;
  display: block;
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0.18px;
  border-bottom: 1px solid #D2D2D2;
  margin-bottom: 20px;
  margin-inline: -3px;
}
.vendor-products-import-modal .upload-file-content .modal-content {
  padding: 20px 39px;
}
.vendor-products-import-modal .upload-file-content .select-import-file {
  border-radius: 5px;
  border: 1px solid #CBCBCB;
  background: linear-gradient(180deg, #E6E6E6 0%, #FEFEFE 100%);
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
  max-width: 200px;
  margin: auto;
  margin-block: 18px 9px;
  padding: 14px 18px;
}
.vendor-products-import-modal .upload-file-content .import-max-file-size {
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
}
.vendor-products-import-modal .upload-file-content .drop-import-file {
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 10px;
  padding-bottom: 15px;
}
.vendor-products-import-modal .upload-file-content .import-file-or-text {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 10px;
}
.vendor-products-import-modal .upload-file-content .download-sample-csv > a {
  padding: 0;
  font-family: var(--font-family);
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 10px;
  text-decoration-line: underline;
  padding-top: 15px;
  border-radius: 0;
}
.vendor-products-import-modal .upload-file-content button.import-product-btn {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.14px;
  padding: 13px 20px;
  border-radius: 60px;
  background: #6ECB44;
  color: #fff;
  margin: auto;
  display: block;
  margin-top: 18px;
  max-width: 162px;
  width: 100%;
}
.vendor-products-import-modal .upload-file-content .import-file-intructions svg {
  width: 100%;
  max-width: 19px;
  max-height: 19px;
  height: 100%;
}
.vendor-products-import-modal .upload-file-content .import-file-intructions {
  display: flex;
  gap: 10px;
  align-items: center;
  padding: 14px 10px;
  border-radius: 4px;
  background: #E9F6E3;
  margin-bottom: 20px;
  color: #65755E;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
}
.vendor-products-import-modal .upload-file-content .selected-file-name {
  color: #65755E;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 14px;
  padding-bottom: 10px;
}
.vendor-products-import-modal .upload-file-content span.selected-file-head {
  font-weight: 500;
}
.vendor-products-import-modal .product-import-modal {
  padding: 0;
  top: auto;
}
.vendor-products-import-modal .product-import-modal:has(.upload-file-content) {
  max-width: 546px;
}
.vendor-products-import-modal .product-import-modal:has(.uploaded-file-status) {
  max-width: 507px;
  width: 100%;
}
.vendor-products-import-modal .uploaded-file-status .modal-content {
  padding-block: 45px 20px;
  padding-inline: 20px;
  text-align: center;
}
.vendor-products-import-modal .uploaded-file-status .import-success-message {
  color: #979797;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 35px;
  padding-block: 18px 30px;
}
.vendor-products-import-modal .uploaded-file-status .total-imported-products {
  display: flex;
  justify-content: space-between;
  background: #F8F9FA;
  padding: 6px 20px;
  border-block: 1px solid #D2D2D2;
  font-size: 15px;
  font-style: normal;
  font-weight: 600;
  color: #979797;
  line-height: 35px;
  margin-bottom: 20px;
}
.vendor-products-import-modal .uploaded-file-status .view-impoted-products-btn button {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0.14px;
  color: #FFF;
  text-align: center;
  padding: 13px 20px;
  border-radius: 60px;
  background: #6ECB44;
  margin: auto;
  max-width: 194px;
  width: 100%;
}

@media screen and (max-width: 767px) {
  .vendor-products-import-modal .product-import-modal:has(.upload-file-content) {
    max-width: 440px;
  }
  .vendor-products-import-modal .product-import-modal:has(.uploaded-file-status) {
    max-width: 440px;
  }
  .vendor-products-import-modal .uploaded-file-status .import-success-message {
    font-size: 18px;
    line-height: 20px;
  }
  .vendor-products-import-modal .uploaded-file-status .total-imported-products {
    font-size: 14px;
  }
}
@media screen and (max-width: 492px) {
  .vendor-products-import-modal label.drop-file-container {
    padding-block: 35px;
  }
  .vendor-products-import-modal .product-import-modal:has(.upload-file-content) {
    max-width: 340px;
  }
  .vendor-products-import-modal .product-import-modal:has(.uploaded-file-status) {
    max-width: 340px;
  }
  .vendor-products-import-modal .upload-file-content .modal-content {
    padding-inline: 10px;
  }
  .vendor-products-import-modal .upload-file-content .import-file-intructions {
    font-size: 10px;
    padding: 8px 10px;
  }
  .vendor-products-import-modal .upload-file-content .select-import-file {
    font-size: 12px;
    margin-block: 14px 9px;
  }
  .vendor-products-import-modal .upload-file-content .drop-import-file {
    font-size: 14px;
  }
  .vendor-products-import-modal .uploaded-file-status .import-success-message {
    font-size: 14px;
    line-height: 16px;
  }
  .vendor-products-import-modal .uploaded-file-status .total-imported-products {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/products/product-import-modal/product-import-modal.component.scss"],"names":[],"mappings":"AACA;EAEI,aAAA;EACA,+BAAA;EACA,WAAA;AADJ;AAEI;EACI,mBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;EACA,kBAAA;EACA,0BAAA;EACA,mBAAA;AAAR;AAGQ;EACI,mBAAA;EACA,kBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,gCAAA;EACA,mBAAA;EACA,mBAAA;AADZ;AAGQ;EACI,kBAAA;AADZ;AAGQ;EACI,kBAAA;EACA,yBAAA;EACA,6DAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAGQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADZ;AAGQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AADZ;AAGQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AADZ;AAIY;EACI,UAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,+BAAA;EACA,iBAAA;EACA,gBAAA;AAFhB;AAKQ;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;AAHZ;AAKQ;EACI,WAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAHZ;AAKQ;EACI,aAAA;EACA,SAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAHZ;AAKQ;EACI,cAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,oBAAA;AAHZ;AAKQ;EACI,gBAAA;AAHZ;AAUI;EACI,UAAA;EACA,SAAA;AARR;AASQ;EACG,gBAAA;AAPX;AASQ;EACI,gBAAA;EACA,WAAA;AAPZ;AAWQ;EACI,wBAAA;EACA,oBAAA;EACA,kBAAA;AATZ;AAWQ;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AATZ;AAWQ;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,+BAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,mBAAA;AATZ;AAYY;EACI,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;EACA,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;AAVhB;;AAkBA;EAKY;IACG,gBAAA;EAnBb;EAqBU;IACI,gBAAA;EAnBd;EAuBU;IACI,eAAA;IACA,iBAAA;EArBd;EAuBU;IACI,eAAA;EArBd;AACF;AA0BA;EAGS;IACG,mBAAA;EA1BV;EAgCU;IACG,gBAAA;EA9Bb;EAgCU;IACI,gBAAA;EA9Bd;EAkCU;IACI,oBAAA;EAhCd;EAkCU;IACI,eAAA;IACA,iBAAA;EAhCd;EAkCU;IACI,eAAA;IACA,sBAAA;EAhCd;EAkCU;IACI,eAAA;EAhCd;EAqCU;IACI,eAAA;IACA,iBAAA;EAnCd;EAqCU;IACI,eAAA;EAnCd;AACF","sourcesContent":["\n.vendor-products-import-modal\n{\n    display: flex;\n    font-family:  var(--font-family);\n    color: #333;\n    label.drop-file-container {\n        padding-block: 60px;\n        height: 100%;\n        width: 100%;\n        display: block;\n        text-align: center;\n        pointer-events: visible;\n        cursor: pointer;\n        border-radius: 4px;\n        border: 1px dashed #9E9E9E;\n        background: #F6F6F6;\n    }\n    .upload-file-content{\n        .modal-header {\n            padding-block: 20px;\n            text-align: center;\n            display: block;\n            font-size: 18px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 20px;\n            letter-spacing: 0.18px;\n            border-bottom: 1px solid #D2D2D2;\n            margin-bottom: 20px;\n            margin-inline: -3px;\n        }\n        .modal-content {\n            padding: 20px 39px;\n        }\n        .select-import-file {\n            border-radius: 5px;\n            border: 1px solid #CBCBCB;\n            background: linear-gradient(180deg, #E6E6E6 0%, #FEFEFE 100%);\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 10px;\n            max-width: 200px;\n            margin: auto;\n            margin-block: 18px 9px;\n            padding: 14px 18px;\n        }\n        .import-max-file-size{\n            font-size: 11px;\n            font-style: normal;\n            font-weight: 400;\n            line-height: 10px;\n        }\n        .drop-import-file{\n            font-size: 16px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 10px;\n            padding-bottom:15px;\n        }\n        .import-file-or-text{\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 10px;\n        }\n        .download-sample-csv{\n            > a{\n                padding: 0;\n                font-family:  var(--font-family);\n                font-size: 11px;\n                font-style: normal;\n                font-weight: 400;\n                line-height: 10px; \n                text-decoration-line: underline;\n                padding-top: 15px;\n                border-radius: 0;\n            }\n        }\n        button.import-product-btn {\n            font-size: 14px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 20px;\n            letter-spacing: 0.14px;\n            padding: 13px 20px;\n            border-radius: 60px;\n            background: #6ECB44;\n            color: #fff;\n            margin: auto;\n            display: block;\n            margin-top: 18px;\n            max-width: 162px;\n            width: 100%;\n        }\n        .import-file-intructions svg {\n            width: 100%;\n            max-width: 19px;\n            max-height: 19px;\n            height: 100%;\n        }\n        .import-file-intructions {\n            display: flex;\n            gap: 10px;\n            align-items: center;\n            padding: 14px 10px;\n            border-radius: 4px;\n            background: #E9F6E3;\n            margin-bottom: 20px;\n            color: #65755E;\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px\n        }\n        .selected-file-name {\n            color: #65755E;\n            font-family:  var(--font-family);\n            font-size: 12px;\n            font-style: normal;\n            font-weight: 500;\n            line-height: 14px;\n            padding-bottom: 10px;\n        }\n        span.selected-file-head {\n            font-weight: 500;\n        }\n       \n \n    }\n       \n   \n    .product-import-modal{\n        padding: 0;\n        top: auto;\n        &:has(.upload-file-content){\n           max-width: 546px; \n        }\n        &:has(.uploaded-file-status){\n            max-width: 507px; \n            width: 100%;\n         }\n    }\n    .uploaded-file-status{\n        .modal-content {\n            padding-block: 45px 20px;\n            padding-inline: 20px;\n            text-align: center;\n        }\n        .import-success-message{\n            color: #979797;\n            font-size: 20px;\n            font-style: normal;\n            font-weight: 600;\n            line-height: 35px;\n            padding-block: 18px 30px;\n        }\n        .total-imported-products {\n            display: flex;\n            justify-content: space-between;\n            background: #F8F9FA;\n            padding: 6px 20px;\n            border-block: 1px solid #D2D2D2;\n            font-size: 15px;\n            font-style: normal;\n            font-weight: 600;\n            color: #979797;\n            line-height: 35px;\n            margin-bottom:20px ;\n        }\n        .view-impoted-products-btn{\n            button{\n                font-size: 14px;\n                font-style: normal;\n                font-weight: 500;\n                line-height: 20px;\n                letter-spacing: 0.14px;\n                color: #FFF;\n                text-align: center;\n                padding: 13px 20px;\n                border-radius: 60px;\n                background: #6ECB44;\n                margin: auto;\n                max-width: 194px;\n                width: 100%;\n            }\n        }\n       \n    }\n}\n\n\n@media screen and (max-width:767px) {\n    .vendor-products-import-modal\n    {\n        .product-import-modal\n        {\n            &:has(.upload-file-content){\n               max-width: 440px; \n            }\n            &:has(.uploaded-file-status){\n                max-width: 440px; \n             }\n        } \n        .uploaded-file-status{\n            .import-success-message{\n                font-size: 18px;   \n                line-height: 20px;   \n            }\n            .total-imported-products{\n                font-size: 14px;\n            }\n        }\n       \n    }\n}\n@media screen and (max-width:492px) {\n    .vendor-products-import-modal\n    {\n         label.drop-file-container{\n            padding-block: 35px;\n        \n        }\n        \n        .product-import-modal\n        {\n            &:has(.upload-file-content){\n               max-width: 340px; \n            }\n            &:has(.uploaded-file-status){\n                max-width: 340px; \n             }\n        } \n        .upload-file-content{\n            .modal-content{\n                padding-inline: 10px;\n            }\n            .import-file-intructions{\n                font-size: 10px;\n                padding: 8px 10px;\n            }   \n            .select-import-file{\n                font-size: 12px;\n                margin-block: 14px 9px;\n            }  \n            .drop-import-file{\n                font-size: 14px;\n            }\n            \n        }\n        .uploaded-file-status{\n            .import-success-message{\n                font-size: 14px;   \n                line-height: 16px;   \n            }\n            .total-imported-products{\n                font-size: 12px;\n            }\n        }\n       \n        \n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
